import { useEffect, useRef, useCallback } from 'react';

export function useSafeAsync() {
  const isMounted = useRef(false);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  return useCallback(async (fn) => {
    try {
      const result = await fn();
      return isMounted.current ? result : undefined;
    } catch (e) {
      if (isMounted.current) {
        throw e;
      }
      return undefined;
    }
  }, []);
}

export default useSafeAsync;
